import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Grid, Box, Container, Paper } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { COLOR_VALUES, buttonStylesByNames, paperStyle } from '../../utils/style';
import { APP_BUTTON_VARIANT, APP_BUTTON_MARGIN, APP_SPORT_MARGIN } from '../config';
import decimalToAmerican from '../../utils/oddsConversion'
import { useAppStore } from '../../store/AppStore';

// TODO: Get rid of makeStyles()
const useStyles = makeStyles((theme) => ({
  root: {},
  paper: paperStyle(theme),
  box: {
    // display: 'inline-block',
    display: 'flex',
    alignItems: 'center'
  },
  // Add "Button" styles for Material UI names 'primary', 'secondary', 'warning', and so on
  ...buttonStylesByNames(theme),
}));

const days = ['Sun', 'Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat'];

/**
 * Application styled Material UI Button with Box around to specify margins using props
 * @component AppSport
 * @param {node} [children] - content to render, overrides .label and .text
 * @param {string} [logo] - name of color from Material UI palette 'primary', 'secondary', 'warning', and so on
 * @param {string} [label] - text to render, alternate to .text
 * @param {string} [text] - text to render, alternate to .label
 */
const AppOddsItem = ({
  children,
  className,
  logo = 'default',
  label, // Alternate to .text prop
  item,
  text, // Alternate to .label prop
  variant = APP_BUTTON_VARIANT,
  ...restOfProps
}) => {
  const classes = useStyles();
  const [state, dispatch] = useAppStore();
  const d = new Date(item.startTime * 1000);
  function ifBadShow0(value){
      if(!value || isNaN(value)){
        return (0).toFixed(2)
      }else return value
    }
  return (
    <Paper className={classes.paper} {...restOfProps} variant="outlined">
      <Box component="div" sx={{
        display: 'flex',
        alignItems: 'center',
        '&:hover': {
          cursor: 'pointer'
        },
      }}>
        <Box component="div" sx={{ display: 'flex', flexDirection: 'column', fontSize: '0.8rem', minWidth: '5.6rem' }}>
          <Box component="span">{days[d.getDay()] + ', ' + d.getDate() + '/' + (d.getMonth() + 1)}</Box>
          <Box component="span">{(d.getHours() < 10 ? '0' + d.getHours() : d.getHours()) + ':' + (d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes())}</Box>
        </Box>
        <Box component="div" sx={{ display: 'flex', alignItems: 'center', marginRight: 'auto' }}>
          {/* <Box
            component="img"
            sx={{
              height: 25,
            }}
            alt="team logo"
            src="/img/teams/manchester_united.png"
          /> */}
          <Box component="span" sx={{ marginLeft: 1, marginRight: 1 }}>{item.event}</Box>
          {/* <Box
            component="img"
            sx={{
              height: 25,
            }}
            alt="team logo"
            src="/img/teams/riverpool.png"
          /> */}
        </Box>

        {item.full_time_result ? (
          <Box component="div" sx={{ display: 'flex', alignItems: 'center', minWidth: '28rem', marginLeft: 3 }}>
            <Box component="div" sx={{ display: 'flex', flexDirection: 'column', fontSize: '0.8rem' }}>
              <Box component="span" sx={{ textAlign: 'center' }}>1</Box>
              <Box component="div" sx={{ display: 'flex', alignItems: 'center' }}>
                <Box component="span" sx={{ padding: '0.2rem 1rem', border: '1px solid #086912', borderRadius: 2, minWidth: '4.2rem', textAlign: 'center', marginRight: 1 }}>
                  {ifBadShow0(state.oddsStyle ? item.full_time_result?.home?.back?.highestOdds?.toFixed(2) : decimalToAmerican(item.full_time_result?.home?.back?.highestOdds))}
                </Box>
                <Box component="span" sx={{ padding: '0.2rem 1rem', border: '1px solid #B11A10', borderRadius: 2, minWidth: '4.2rem', textAlign: 'center' }}>
                  {ifBadShow0(state.layBetSlipStyle ? 
                    state.oddsStyle ? (item.full_time_result?.home?.lay?.highestOdds/(item.full_time_result?.home?.lay?.highestOdds-1)).toFixed(2) : decimalToAmerican(item.full_time_result?.home?.lay?.highestOdds/(item.full_time_result?.home?.lay?.highestOdds-1))
                  : state.oddsStyle ? item.full_time_result?.home?.lay?.highestOdds?.toFixed(2) : decimalToAmerican(item.full_time_result?.home?.lay?.highestOdds)
                  )}
                </Box>
              </Box>
            </Box>
            <Box component="div" sx={{ display: 'flex', flexDirection: 'column', fontSize: '0.8rem', marginLeft: 1 }}>
              <Box component="span" sx={{ textAlign: 'center' }}>X</Box>
              <Box component="div" sx={{ display: 'flex', alignItems: 'center' }}>
                <Box component="span" sx={{ padding: '0.2rem 1rem', border: '1px solid #086912', borderRadius: 2, minWidth: '4.2rem', textAlign: 'center', marginRight: 1 }}>
                  {ifBadShow0(state.oddsStyle ? item.full_time_result?.draw?.back?.highestOdds?.toFixed(2) : decimalToAmerican(item.full_time_result?.draw?.back?.highestOdds))}
                </Box>
                <Box component="span" sx={{ padding: '0.2rem 1rem', border: '1px solid #B11A10', borderRadius: 2, minWidth: '4.2rem', textAlign: 'center' }}>
                  {ifBadShow0(state.layBetSlipStyle ? 
                    state.oddsStyle ? (item.full_time_result?.draw?.lay?.highestOdds/(item.full_time_result?.draw?.lay?.highestOdds-1)).toFixed(2) : decimalToAmerican(item.full_time_result?.draw?.lay?.highestOdds/(item.full_time_result?.draw?.lay?.highestOdds-1))
                  : state.oddsStyle ? item.full_time_result?.draw?.lay?.highestOdds?.toFixed(2) : decimalToAmerican(item.full_time_result?.draw?.lay?.highestOdds)
                  )}
                  </Box>
              </Box>
            </Box>
            <Box component="div" sx={{ display: 'flex', flexDirection: 'column', fontSize: '0.8rem', marginLeft: 1 }}>
              <Box component="span" sx={{ textAlign: 'center' }}>2</Box>
              <Box component="div" sx={{ display: 'flex', alignItems: 'center' }}>
                <Box component="span" sx={{ padding: '0.2rem 1rem', border: '1px solid #086912', borderRadius: 2, minWidth: '4.2rem', textAlign: 'center', marginRight: 1 }}>
                  {ifBadShow0(state.oddsStyle ? item.full_time_result?.away?.back?.highestOdds?.toFixed(2) : decimalToAmerican(item.full_time_result?.away?.back?.highestOdds))}
                </Box>
                <Box component="span" sx={{ padding: '0.2rem 1rem', border: '1px solid #B11A10', borderRadius: 2, minWidth: '4.2rem', textAlign: 'center' }}>
                  {ifBadShow0(state.layBetSlipStyle ? 
                    state.oddsStyle ? (item.full_time_result?.away?.lay?.highestOdds/(item.full_time_result?.away?.lay?.highestOdds-1)).toFixed(2) : decimalToAmerican(item.full_time_result?.away?.lay?.highestOdds/(item.full_time_result?.away?.lay?.highestOdds-1))
                  : state.oddsStyle ? item.full_time_result?.away?.lay?.highestOdds?.toFixed(2) : decimalToAmerican(item.full_time_result?.away?.lay?.highestOdds)
                  )}
                  </Box>                
              </Box>
            </Box>
          </Box>
        ) : (
          <Box component="div" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', minWidth: '28rem', marginLeft: 3 }}>
            <Box component="div" sx={{ display: 'flex', flexDirection: 'column', fontSize: '0.8rem' }}>
              <Box component="span" sx={{ textAlign: 'center' }}>1</Box>
              <Box component="div" sx={{ display: 'flex', alignItems: 'center' }}>
                <Box component="span" sx={{ padding: '0.2rem 1rem', border: '1px solid #086912', borderRadius: 2, textAlign: 'center', minWidth: '8rem', marginRight: 1 }}>
                  {ifBadShow0(state.oddsStyle ? item.moneyline?.home?.highestOdds?.toFixed(2) : decimalToAmerican(item.moneyline?.home?.highestOdds))}
                </Box>
              </Box>
            </Box>
            <Box component="div" sx={{ display: 'flex', flexDirection: 'column', fontSize: '0.8rem', marginLeft: 1 }}>
              <Box component="span" sx={{ textAlign: 'center' }}>2</Box>
              <Box component="div" sx={{ display: 'flex', alignItems: 'center' }}>
                <Box component="span" sx={{ padding: '0.2rem 1rem', border: '1px solid #086912', borderRadius: 2, textAlign: 'center', minWidth: '8rem', marginRight: 1 }}>
                  {ifBadShow0(state.oddsStyle ? item.moneyline?.away?.highestOdds?.toFixed(2) : decimalToAmerican(item.moneyline?.away?.highestOdds))}
                </Box>
              </Box>
            </Box>
          </Box>
        )}
        
        
        
      </Box>
    </Paper>
  );
};

AppOddsItem.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  logo: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  text: PropTypes.string,
  variant: PropTypes.oneOf(['contained', 'outlined', 'text']),
  onClick: PropTypes.func,
};

export default AppOddsItem;
